module.exports = __webpack_public_path__ + "img/10.aa7894f9.png";